import Axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { api_url } from "../../../config";
import FormulaireMotDePasse from "../../common/HorsConnexion/FormulaireMotDePasse";
import {
  MESSAGE_SERVEUR_INDISPONIBLE,
  extraireErreurMotDePasse,
  messageErreur,
} from "../../common/HorsConnexion/horsConnexion";
import "../../common/HorsConnexion/hors-connexion.scss";

/**
 * Changement du mot de passe depuis « Votre compte » : même formulaire que les
 * écrans hors connexion (œil, règles cochées, confirmation). Même appel
 * qu'avant (PATCH `route` avec le mot de passe), puis notification et
 * fermeture du panneau ; un refus de l'API s'affiche sous le champ.
 */
const ModifyPassword = ({ route, showPassword, setShowPassword }) => {
  const [enregistrement, setEnregistrement] = useState(false);
  const [erreurMdp, setErreurMdp] = useState(null);
  const [erreurGenerale, setErreurGenerale] = useState(null);

  function enregistrer(password) {
    setEnregistrement(true);
    setErreurGenerale(null);
    Axios.patch(api_url + route, { password })
      .then(() => {
        toast.success("Votre mot de passe a bien été modifié, utilisez-le lors de vos prochaines connexions.");
        setShowPassword(false);
      })
      .catch((err) => {
        const donnees = err.response && err.response.data;
        const messageMdp = extraireErreurMotDePasse(donnees);
        if (messageMdp) setErreurMdp(messageMdp);
        else setErreurGenerale(messageErreur(donnees) || MESSAGE_SERVEUR_INDISPONIBLE);
        setEnregistrement(false);
      });
  }

  if (!showPassword) return null;

  return (
    <div className="hc compte__mdp">
      <div className="compte__mdp-entete">
        <h3 className="compte__mdp-titre">Changer mon mot de passe</h3>
        <button type="button" className="lien" onClick={() => setShowPassword(false)}>
          Annuler
        </button>
      </div>
      <FormulaireMotDePasse
        onEnregistrer={enregistrer}
        enregistrement={enregistrement}
        erreurMdp={erreurMdp}
        onEffacerErreurMdp={() => setErreurMdp(null)}
        erreurGenerale={erreurGenerale}
      />
    </div>
  );
};

export default ModifyPassword;
